import Player from '@vimeo/player';

const videoContainers = document.querySelectorAll('[data-video-url]');

videoContainers.forEach(container => {
    const playButton = container.querySelector('.custom-video-play');
    const videoUrl = container.dataset.videoUrl;
    const autoplay = container.hasAttribute('data-video-autoplay');

    if (!videoUrl) {
        return;
    }

    const playerOptions = {
        url: videoUrl,
        controls: false,
        title: false,
        byline: false,
        portrait: false,
        dnt: true,
        keyboard: false,
    };

    if (autoplay) {
        playerOptions.background = true;
    }

    const player = new Player(container, playerOptions);

    playButton.addEventListener('click', () => {
        container.classList.add('started');

        player.getPaused().then((paused) => {
            if (paused) {
                container.classList.add('playing');
                player.play();
            } else {
                container.classList.remove('playing');
                player.pause();
            }
        });
    });

    player.on('loaded', () => {
        resizeCoverVideos(container.closest('section'));
        setTimeout(() => container.classList.add('loaded'), 100);
    });

    player.on('ended', () => {
        container.classList.remove('playing');
    });
});